module.exports = __webpack_public_path__ + "img/get-added.8d10997a.jpg";